/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './accounting-collection-ledger.reducer';

export const AccountingCollectionLedger = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const accountingCollectionLedgerList = useAppSelector(state => state.accountingCollectionLedger.entities);
  const loading = useAppSelector(state => state.accountingCollectionLedger.loading);
  const totalItems = useAppSelector(state => state.accountingCollectionLedger.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="accounting-collection-ledger-heading" data-cy="AccountingCollectionLedgerHeading">
        <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.home.title">Accounting Collection Ledgers</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/accounting-collection-ledger/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.home.createLabel">
              Create new Accounting Collection Ledger
            </Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.accountingCollectionLedger.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {accountingCollectionLedgerList && accountingCollectionLedgerList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('ledgerNo')}>
                  <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.ledgerNo">Ledger No</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('ledgerNo')} />
                </th>
                <th className="hand" onClick={sort('amount')}>
                  <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.amount">Amount</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('amount')} />
                </th>
                <th className="hand" onClick={sort('remarks')}>
                  <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.remarks">Remarks</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('remarks')} />
                </th>
                <th className="hand" onClick={sort('pendingAmount')}>
                  <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.pendingAmount">Pending Amount</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('pendingAmount')} />
                </th>
                <th className="hand" onClick={sort('collectedById')}>
                  <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.collectedById">Collected By Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('collectedById')} />
                </th>
                <th className="hand" onClick={sort('collectedByType')}>
                  <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.collectedByType">Collected By Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('collectedByType')} />
                </th>
                <th className="hand" onClick={sort('depositedById')}>
                  <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.depositedById">Deposited By Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('depositedById')} />
                </th>
                <th className="hand" onClick={sort('depositedByType')}>
                  <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.depositedByType">Deposited By Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('depositedByType')} />
                </th>
                <th className="hand" onClick={sort('closed')}>
                  <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.closed">Closed</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('closed')} />
                </th>
                <th className="hand" onClick={sort('entityId')}>
                  <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.entityId">Entity Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('entityId')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('lastUpdated')}>
                  <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.lastUpdated">Last Updated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdated')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampEntry')}>
                  <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.timestampEntry">Timestamp Entry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampEntry')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.expense">Expense</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.income">Income</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.account">Account</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.entityType">Entity Type</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {accountingCollectionLedgerList.map((accountingCollectionLedger, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/accounting-collection-ledger/${accountingCollectionLedger.id}`} color="link" size="sm">
                      {accountingCollectionLedger.id}
                    </Button>
                  </td>
                  <td>{accountingCollectionLedger.ledgerNo}</td>
                  <td>{accountingCollectionLedger.amount}</td>
                  <td>{accountingCollectionLedger.remarks}</td>
                  <td>{accountingCollectionLedger.pendingAmount}</td>
                  <td>{accountingCollectionLedger.collectedById}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.AddedByType.${accountingCollectionLedger.collectedByType}`} />
                  </td>
                  <td>{accountingCollectionLedger.depositedById}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.AddedByType.${accountingCollectionLedger.depositedByType}`} />
                  </td>
                  <td>{accountingCollectionLedger.closed ? 'true' : 'false'}</td>
                  <td>{accountingCollectionLedger.entityId}</td>
                  <td>{accountingCollectionLedger.active ? 'true' : 'false'}</td>
                  <td>{accountingCollectionLedger.cursor}</td>
                  <td>{accountingCollectionLedger.lastUpdated}</td>
                  <td>{accountingCollectionLedger.microSec}</td>
                  <td>{accountingCollectionLedger.timestampEntry}</td>
                  <td>
                    {accountingCollectionLedger.expense ? (
                      <Link to={`/accounting-transaction/${accountingCollectionLedger.expense.id}`}>
                        {accountingCollectionLedger.expense.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {accountingCollectionLedger.income ? (
                      <Link to={`/accounting-transaction/${accountingCollectionLedger.income.id}`}>
                        {accountingCollectionLedger.income.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {accountingCollectionLedger.account ? (
                      <Link to={`/accounting-bank-account/${accountingCollectionLedger.account.id}`}>
                        {accountingCollectionLedger.account.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {accountingCollectionLedger.entityType ? (
                      <Link to={`/clinical-dictionary/${accountingCollectionLedger.entityType.id}`}>
                        {accountingCollectionLedger.entityType.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/accounting-collection-ledger/${accountingCollectionLedger.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/accounting-collection-ledger/${accountingCollectionLedger.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/accounting-collection-ledger/${accountingCollectionLedger.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.home.notFound">
                No Accounting Collection Ledgers found
              </Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={accountingCollectionLedgerList && accountingCollectionLedgerList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default AccountingCollectionLedger;
